import { useQuery } from "@tanstack/react-query";

import { toApiError } from "../../lib/apiError";
import { useApiClient } from "../useApiClient";

import { TRADES_QUERY_KEY } from "./useTrades";

export function useTrade(tradeId: string) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...TRADES_QUERY_KEY, "detail", tradeId],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/trades/{trade_id}", {
        params: { path: { trade_id: tradeId } },
      });
      if (error !== undefined) {
        throw new Error(toApiError(error, `Failed to load trade ${tradeId}`));
      }
      return data;
    },
    enabled: tradeId.length > 0,
  });
}
